import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/provide/common.service';
import { StateManagementService } from 'src/app/provide/state-management.service';
import { CustomValidators } from 'src/app/provide/Validators';
import { environment } from 'src/environments/environment';
declare var $;
@Component({
    selector: 'app-referal',
    templateUrl: './referal.component.html',
    styleUrls: ['./referal.component.scss'],
    standalone: false
})
export class ReferalComponent implements OnInit {

  profileData : any
  referUrl : string = "ghnL45"
  loading: boolean = false;
  listData : any = []
  currentPage: number = 1;
  itemPerPage: number = 10;
  totalItems: any;
  withdrawForm : UntypedFormGroup
  constructor(
    private activatedroute: ActivatedRoute,
    public commonService: CommonService,
    private router: Router,
    public stateManagement: StateManagementService
  ) {

  }
  
  usertype : any = "CUSTOMER"

  ngOnInit(): void {
    this.commonService.profile_user.subscribe((res)=>{
      this.profileData = res
      const userType = localStorage.getItem("userType");
      const routes = {
        CUSTOMER: "signup-customer",
        RETAILER: "signup-retailer",
        SERVICE_PROVIDER: "signup-service-provider"
      };
     
      
      const route = routes[userType] || "signup";
      this.referUrl = `${environment.webUrl}${route}?refferalCode=${this.profileData.refferalCode}`


    })
    this.withdrawformFunction()
    this.listApi()
  }

  withdrawformFunction(){
    const customValidators = new CustomValidators()
    this.withdrawForm = new UntypedFormGroup({
      // image: new FormControl('', [
      //   Validators.required
      // ]),
      toWallet: new UntypedFormControl('', 
  
        customValidators.walletAddress()
      ),
      amount: new UntypedFormControl( "",customValidators.amount()),
    });
  }

  referNowModal(){
    $('#shareCodeModal').modal('show')
  }
  refferNow(){

    // this.copyText(this.referUrl) 
    if (navigator.share) {
      navigator.share({
        title: 'Join me on eXobe platform!',
        text: `Sign up using my referral link and get a bonus!`,
        url: this.referUrl
      })
      .then(() => console.log('Shared successfully'))
      .catch((error) =>{
        console.log( error.message)
        if(error.message != 'Share canceled'){
          $('#shareCodeModal').modal('show')
 
        }
      }
    );
    } else {
      // console.warn('Web Share API is not supported in your browser.');
      $('#shareCodeModal').modal('show')
    }
   
  }

  copyText(text: string): void {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        // console.log('Text copied to clipboard');
        this.commonService.showSuccessToast("Copied to clipboard.")
      }).catch(err => {
        console.error('Failed to copy text: ', err);
      });
    } else {
      // Fallback for older browsers
      this.fallbackCopyText(text);
    }
  }
  shortenAddress(address) {
    if (!address || address.length < 10) return address;
    return address.slice(0, 4) + '....' + address.slice(-3);
  }
  private fallbackCopyText(text: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      // console.log('Text copied using fallback method');
      this.commonService.showSuccessToast("Copied to clipboard.")
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }
    document.body.removeChild(textarea);
  }
  transactionType =  "REFERAL"
  listApi(type?){
    let url = `cryptoTransaction/cryptoTransactionList`
    let apiReqData: any = {
      // userType: "WHOLE_SALER",
      page: this.currentPage,
      limit: this.itemPerPage,
     
        }
        if(type){apiReqData.transactionType= type};
    this.commonService.postApi(url, apiReqData, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.commonService.successToast(res['responseMessage']);
          this.listData = res.result.docs
          this.totalItems = res.result.total
          this.commonService.hideSpinner();

        }
        this.loading = false;
      },


      (err: any) => {
        this.loading = false;
        if (err.responseCode == 409) {
          this.commonService.hideSpinner();
          this.commonService.errorToast(err.responseMessage);
        }
      }
    );
  }
  pagination(event: number) {
    this.currentPage = event;
    this.listApi()
  }
  isSubmitted = false
  withdrawToken(){
    this.isSubmitted = true
    if(this.withdrawForm.invalid){
      return
    }
    let url = `cryptoTransaction/withdraw`
    let apiReqData: any = {
      // userType: "WHOLE_SALER",
      toWallet: this.withdrawForm.value.toWallet,
      amount: Number(this.withdrawForm.value.amount),
     
        }
       this.loading = true
    this.commonService.postApi(url, apiReqData, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.commonService.showSuccessToast(res['responseMessage']);
          this.commonService.hideSpinner();
        }
        this.listApi()
        this.loading = false;
        $('#withdrawModal').modal('hide')
      },


      (err: any) => {
        this.loading = false;
        this.listApi()
        $('#withdrawModal').modal('hide')
        if (err.responseCode == 409) {
          this.commonService.hideSpinner();
          this.commonService.errorToast(err.responseMessage);
        }
      }
    );
  }

  preventSpace(event: any) {
    if (event.charCode == 32 && !event.target.value) {
      event.preventDefault();
    }
  }
}
